export var UserPreferencesPDFPageOrientationEnum;
(function (UserPreferencesPDFPageOrientationEnum) {
    UserPreferencesPDFPageOrientationEnum["Vertical"] = "vertical";
    UserPreferencesPDFPageOrientationEnum["Horizontal"] = "horizontal";
})(UserPreferencesPDFPageOrientationEnum || (UserPreferencesPDFPageOrientationEnum = {}));
export var UserPreferencesPDFPageMarginEnum;
(function (UserPreferencesPDFPageMarginEnum) {
    UserPreferencesPDFPageMarginEnum["M10MM"] = "M_10MM";
    UserPreferencesPDFPageMarginEnum["M5MM"] = "M_5MM";
    UserPreferencesPDFPageMarginEnum["M15MM"] = "M_15MM";
    UserPreferencesPDFPageMarginEnum["M20MM"] = "M_20MM";
})(UserPreferencesPDFPageMarginEnum || (UserPreferencesPDFPageMarginEnum = {}));
export var UserPreferencesPDFPageSizeEnum;
(function (UserPreferencesPDFPageSizeEnum) {
    UserPreferencesPDFPageSizeEnum["None"] = "None";
    UserPreferencesPDFPageSizeEnum["A4"] = "A4";
    UserPreferencesPDFPageSizeEnum["A3"] = "A3";
    UserPreferencesPDFPageSizeEnum["Legal"] = "Legal";
    UserPreferencesPDFPageSizeEnum["Letter"] = "Letter";
})(UserPreferencesPDFPageSizeEnum || (UserPreferencesPDFPageSizeEnum = {}));
